// import React, { useState, useEffect } from "react";
// import { IoCloseCircleOutline } from "react-icons/io5";
// import { useHistory } from "react-router-dom";
// import OtpVerification_Login from "./OtpVerification_Login";
// import SignUp1 from "../auth/SignUp1";
// import axios from "axios";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { IoAlertCircleOutline } from "react-icons/io5";

// const Login1 = ({ onClose, isOpen, defaultMobile }) => {
//   const [mobile, setMobile] = useState(defaultMobile || "");
//   const [countryCode, setCountryCode] = useState("+91");
//   const [showOtpModal, setShowOtpModal] = useState(false);
//   const [showSignUpModal, setShowSignUpModal] = useState(false);
//   const history = useHistory();
//   // Inside your component
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [errors, setErrors] = useState({
//     mobile: "",
//   });

//   // Prevent background scrolling when modal is open
//   useEffect(() => {
//     if (showOtpModal || showSignUpModal || isOpen) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }
//     // Cleanup when component unmounts
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, [showOtpModal, showSignUpModal, isOpen]);

//   const resetForm = () => {
//     setMobile(defaultMobile || "");
//     setCountryCode("+91");
//     setShowOtpModal(false);
//   };

//   useEffect(() => {
//     if (isOpen) {
//       resetForm();
//     }
//   }, [isOpen]);

//   if (!isOpen) return null;

//   const handleLogin = async () => {
//     let hasError = false;
//     const newErrors = { mobile: "" };

//     if (!mobile.trim()) {
//       newErrors.mobile = "Mobile number is required";
//       hasError = true;
//     } else if (mobile.trim().length < 10) {
//       newErrors.mobile = "Mobile number must be at least 10 digits";
//       hasError = true;
//     }

//     setErrors(newErrors);

//     if (hasError) {
//       toast.error("Please enter a valid mobile number");
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/cust_api/generate-login-otp`,
//         {
//           mobile_number: mobile,
//           country_code: countryCode,
//         },
//       );

//       const data = response.data;

//       if (data.status === 1) {
//         toast.success("OTP sent successfully!");
//         setShowOtpModal(true);
//       } else {
//         toast.error("User not found. Please Sign Up First");
//       }
//     } catch (error) {
//       if (
//         error.response &&
//         error.response.data &&
//         error.response.data.message
//       ) {
//         toast.error(error.response.data.message);
//       } else {
//         toast.error("Something went wrong. Please try again.");
//       }
//       console.error("Login OTP Error:", error);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // how SignUp modal
//   if (showSignUpModal) {
//     return (
//       <SignUp1
//         isOpen={true}
//         onClose={() => {
//           setShowSignUpModal(false);
//           onClose();
//         }}
//         onSwitchToLogin={() => setShowSignUpModal(false)}
//         defaultMobile={mobile}
//       />
//     );
//   }

//   return (
//     <>
//       {showOtpModal ? (
//         <OtpVerification_Login
//           mobileNumber={mobile}
//           countryCode={countryCode}
//           fullName={""}
//           userType={"customer"}
//           onClose={() => {
//             setShowOtpModal(false);
//             onClose();
//           }}
//           onSwitchToLogIn={() => setShowOtpModal(false)}
//         />
//       ) : (
//         <div className="fixed inset-0 flex items-center justify-center bg-green bg-opacity-50 px-4 z-50">
//           <div className="bg-green  rounded-2xl shadow-lg p-4 md:p-8 w-full max-w-sm">
//             {/* Close Button */}
//             <div className="flex justify-end">
//               <button
//                 onClick={() => {
//                   resetForm();
//                   onClose();
//                 }}
//                 className="text-black hover:text-black"
//               >
//                 <IoCloseCircleOutline size={20} />
//               </button>
//             </div>

//             {/* Login Title */}
//             <h2 className="text-center text-2xl font-semibold text-gray-900 mb-4">
//               Login
//             </h2>

//             {/* Mobile Input with Country Code */}
//             <label className="block text-sm font-medium text-gray-700 mb-1">
//               Mobile Number{" "}
//               <span className="text-red-500 text-xl font-bold">*</span>
//             </label>
//             <>
//               <div className="flex gap-2 mb-1">
//                 <div className="w-1/3">
//                   <select
//                     className="w-full p-3 border border-gray-300 rounded-lg text-gray-700 bg-white focus:outline-none"
//                     value={countryCode}
//                     onChange={(e) => setCountryCode(e.target.value)}
//                   >
//                     <option value="+91">IN +91</option>
//                     <option value="+1">US +1</option>
//                     <option value="+44">UK +44</option>
//                     <option value="+61">AU +61</option>
//                     <option value="+81">JP +81</option>
//                     <option value="+49">DE +49</option>
//                     <option value="+971">AE +971</option>
//                     <option value="+7">RU +7</option>
//                     <option value="+27">ZA +27</option>
//                   </select>
//                 </div>
//                 <input
//                   type="text"
//                   placeholder="Mobile Number"
//                   value={mobile}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     if (/^\d{0,10}$/.test(value)) {
//                       setMobile(value);
//                       setErrors({ ...errors, mobile: "" });
//                     }
//                   }}
//                   className={`w-full p-3 pr-10 border rounded-lg text-gray-700 bg-white focus:outline-none ${
//                     errors.mobile ? "border-red-500" : "border-gray-300"
//                   }`}
//                 />
//               </div>
//               {errors.mobile && (
//                 <p className="text-sm text-red-500 mt-1 flex items-center gap-1">
//                   <IoAlertCircleOutline size={16} className="text-red-500" />
//                   {errors.mobile}
//                 </p>
//               )}
//             </>

//             {/* Login Button */}
//             <button
//               onClick={handleLogin}
//               className={`w-full py-3 mt-3 rounded-lg text-lg font-medium transition ${
//                 isSubmitting
//                   ? "bg-gray-400 text-white cursor-not-allowed"
//                   : "my-bg text-white hover:my-bg"
//               }`}
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? "Sending OTP..." : "Login"}
//             </button>

//             {/* Signup Link */}
//             <p className="text-center text-gray-500 text-sm mt-4">
//               Don't have an account?{" "}
//               <button
//                 onClick={() => setShowSignUpModal(true)}
//                 className="my-text font-semibold hover:underline"
//               >
//                 Sign Up
//               </button>
//             </p>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Login1;



import React, { useState, useEffect } from "react";
import { IoCloseOutline, IoAlertCircleOutline, IoShieldCheckmarkOutline } from "react-icons/io5";
import { FiCheck } from "react-icons/fi";
import { FcGoogle } from "react-icons/fc";
import { FaApple, FaLock } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import OtpVerification_Login from "./OtpVerification_Login";
import SignUp1 from "../auth/SignUp1";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login1 = ({ onClose, isOpen, defaultMobile }) => {
  const [mobile, setMobile] = useState(defaultMobile || "");
  const [countryCode, setCountryCode] = useState("+91");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const history = useHistory();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({
    mobile: "",
  });

  // Prevent background scrolling when modal is open
  useEffect(() => {
    if (showOtpModal || showSignUpModal || isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showOtpModal, showSignUpModal, isOpen]);

  const resetForm = () => {
    setMobile(defaultMobile || "");
    setCountryCode("+91");
    setShowOtpModal(false);
  };

  useEffect(() => {
    if (isOpen) {
      resetForm();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleLogin = async () => {
    let hasError = false;
    const newErrors = { mobile: "" };

    if (!mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
      hasError = true;
    } else if (mobile.trim().length < 10) {
      newErrors.mobile = "Mobile number must be at least 10 digits";
      hasError = true;
    }

    setErrors(newErrors);

    if (hasError) {
      toast.error("Please enter a valid mobile number");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/cust_api/generate-login-otp`,
        {
          mobile_number: mobile,
          country_code: countryCode,
        }
      );

      const data = response.data;

      if (data.status === 1) {
        toast.success("OTP sent successfully!");
        setShowOtpModal(true);
      } else {
        toast.error("User not found. Please Sign Up First");
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again.");
      }
      console.error("Login OTP Error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (showSignUpModal) {
    return (
      <SignUp1
        isOpen={true}
        onClose={() => {
          setShowSignUpModal(false);
          onClose();
        }}
        onSwitchToLogin={() => setShowSignUpModal(false)}
        defaultMobile={mobile}
      />
    );
  }

  return (
    <>
      {showOtpModal ? (
        <OtpVerification_Login
          mobileNumber={mobile}
          countryCode={countryCode}
          fullName={""}
          userType={"customer"}
          onClose={() => {
            setShowOtpModal(false);
            onClose();
          }}
          onSwitchToLogIn={() => setShowOtpModal(false)}
        />
      ) : (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 px-3 z-50">
          <div className="relative bg-white rounded-xl shadow-xl p-4 md:p-5 w-full max-w-sm">
            {/* Close Button */}
            <button
              onClick={() => {
                resetForm();
                onClose();
              }}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 transition-colors"
            >
              <IoCloseOutline size={20} />
            </button>

            {/* Lock Icon Badge */}
            <div className="flex justify-center mb-2">
              <div className="w-10 h-10 rounded-full bg-[#fdf0f3] flex items-center justify-center">
                <FaLock className="text-[#700c28] text-base" />
              </div>
            </div>

            {/* Login Title & Subtitle */}
            <div className="text-center mb-3">
              <h2 className="text-lg font-bold text-gray-900 leading-tight">Welcome Back!</h2>
              <p className="text-[11px] text-gray-500 mt-0.5">
                Login to continue your real estate journey
              </p>
            </div>

            {/* Mobile Input Field Label */}
            <label className="block text-xs font-semibold text-gray-800 mb-1">
              Mobile Number <span className="text-red-500">*</span>
            </label>

            {/* Input Row */}
            <div className="flex gap-1.5">
              {/* Country Code Dropdown */}
              <div className="relative w-1/3">
                <select
                  className="w-full py-1.5 px-2 border border-gray-300 rounded-lg text-gray-800 bg-white font-medium focus:outline-none focus:border-[#700c28] appearance-none cursor-pointer text-xs"
                  value={countryCode}
                  onChange={(e) => setCountryCode(e.target.value)}
                >
                  <option value="+91">🇮🇳 +91</option>
                  <option value="+1">🇺🇸 +1</option>
                  <option value="+44">🇬🇧 +44</option>
                  <option value="+61">🇦🇺 +61</option>
                  <option value="+81">🇯🇵 +81</option>
                  <option value="+49">🇩🇪 +49</option>
                  <option value="+971">🇦🇪 +971</option>
                  <option value="+7">🇷🇺 +7</option>
                  <option value="+27">🇿🇦 +27</option>
                </select>
                <span className="absolute right-1.5 top-1/2 -translate-y-1/2 pointer-events-none text-[9px] text-gray-500">
                  ▼
                </span>
              </div>

              {/* Mobile Number Input */}
              <div className="w-2/3">
                <input
                  type="text"
                  placeholder="Enter 10-digit mobile number"
                  value={mobile}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) {
                      setMobile(value);
                      setErrors({ ...errors, mobile: "" });
                    }
                  }}
                  className={`w-full py-1.5 px-2.5 border rounded-lg text-gray-800 bg-white placeholder-gray-400 focus:outline-none text-xs ${
                    errors.mobile ? "border-red-500" : "border-gray-300 focus:border-[#700c28]"
                  }`}
                />
              </div>
            </div>

            {/* Error Message */}
            {errors.mobile && (
              <p className="text-[10px] text-red-500 mt-1 flex items-center gap-1">
                <IoAlertCircleOutline size={12} />
                {errors.mobile}
              </p>
            )}

            {/* Submit Button */}
            <button
              onClick={handleLogin}
              disabled={isSubmitting}
              className={`w-full py-2 mt-3 rounded-lg font-semibold text-white transition-all shadow-sm text-xs ${
                isSubmitting
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#700c28] hover:bg-[#580920] active:scale-[0.99]"
              }`}
            >
              {isSubmitting ? "Sending OTP..." : "Login"}
            </button>

            {/* OR Divider */}
            <div className="relative flex py-2.5 items-center">
              <div className="flex-grow border-t border-gray-200"></div>
              <span className="flex-shrink mx-3 text-[10px] font-medium text-gray-400 tracking-wider">
                OR
              </span>
              <div className="flex-grow border-t border-gray-200"></div>
            </div>

            <p className="text-center text-[10px] font-medium text-gray-500 mb-1.5">
              Login with
            </p>

            {/* Social Login Buttons */}
            <div className="grid grid-cols-2 gap-2 mb-3">
              <button
                type="button"
                className="flex items-center justify-center gap-1.5 py-1.5 px-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors text-xs font-semibold text-gray-700"
              >
                <FcGoogle size={15} />
                <span>Google</span>
              </button>
              <button
                type="button"
                className="flex items-center justify-center gap-1.5 py-1.5 px-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors text-xs font-semibold text-gray-700"
              >
                <FaApple size={15} className="text-black" />
                <span>Apple</span>
              </button>
            </div>

            {/* Benefits Box */}
            <div className="bg-[#fdf0f3] rounded-xl p-2.5 mb-3 border border-[#f7d6de]">
              <div className="flex items-center gap-1.5 mb-1.5">
                <IoShieldCheckmarkOutline className="text-[#700c28] text-base" />
                <h4 className="font-bold text-xs text-[#700c28]">
                  Why login to ZeroBriks?
                </h4>
              </div>

              <div className="grid grid-cols-2 gap-x-1.5 gap-y-1 text-[10px] text-gray-700 font-medium">
                <div className="flex items-center gap-1">
                  <FiCheck className="text-emerald-600 flex-shrink-0" size={12} />
                  <span className="truncate">Save favourite properties</span>
                </div>
                <div className="flex items-center gap-1">
                  <FiCheck className="text-emerald-600 flex-shrink-0" size={12} />
                  <span className="truncate">Manage your properties</span>
                </div>
                <div className="flex items-center gap-1">
                  <FiCheck className="text-emerald-600 flex-shrink-0" size={12} />
                  <span className="truncate">Personalised recommendations</span>
                </div>
                <div className="flex items-center gap-1">
                  <FiCheck className="text-emerald-600 flex-shrink-0" size={12} />
                  <span className="truncate">Access exclusive offers</span>
                </div>
                <div className="flex items-center gap-1">
                  <FiCheck className="text-emerald-600 flex-shrink-0" size={12} />
                  <span className="truncate">Track enquiries</span>
                </div>
                <div className="flex items-center gap-1">
                  <FiCheck className="text-emerald-600 flex-shrink-0" size={12} />
                  <span className="truncate">Faster & secure experience</span>
                </div>
              </div>
            </div>

            {/* Signup Link */}
            <p className="text-center text-xs text-gray-600 font-medium">
              Don't have an account?{" "}
              <button
                type="button"
                onClick={() => setShowSignUpModal(true)}
                className="text-[#700c28] font-bold hover:underline"
              >
                Sign Up
              </button>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default Login1;